module.exports = __webpack_public_path__ + "img/04.dd7a45f6.jpg";